import { Box, styled } from '@mui/material';

export const ActionColumnSC = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
